import { useSelector } from 'react-redux';

import type { RootState } from '../../../../../store';

export const useHistoryTablesData = () => {
  return {
    claimList: useSelector((state: RootState) => state.claims.list),
    assessmentList: useSelector((state: RootState) => state.clientAssessment.list),
    clientSNList: useSelector((state: RootState) => state.clientSupervisions.list),
    btSNList: useSelector((state: RootState) => state.btSupervision.list),
    parentSNList: useSelector((state: RootState) => state.parentSupervision.list),
    groupSNList: useSelector((state: RootState) => state.groupParentSupervision.list),
    sessions: useSelector((state: RootState) => state.sessions.list),
    invoices: useSelector((state: RootState) => state.claimsInvoice.list),
    onboardingQuestionnaires: useSelector(
      (state: RootState) => state.onboardingQuestionnaire.onboardingQuestionnaires,
    ),
    intakeQuestionnaires: useSelector((state: RootState) => state.intakeQuestionnaire.intakeQuestionnaires),
    clients: useSelector((state: RootState) => state.clients.allClientsList),
    providers: useSelector((state: RootState) => state.providers.allProvidersList),
  };
};
